<template>
  <div>
    <VoluntaryPaymentsChart />
    <InterestRateScenario />
    <PropertyValueAppreciationRate />
    <DoYouWantImmediateCash />
    <ConsiderVoluntaryPayments />
    <SchedulePayments />
  </div>
</template>

<script>
import InterestRateScenario from './InterestRateScenario.vue';
import PropertyValueAppreciationRate from './PropertyValueAppreciationRate.vue';
import DoYouWantImmediateCash from './DoYouWantImmediateCash.vue';
import ConsiderVoluntaryPayments from './ConsiderVoluntaryPayments.vue';
import VoluntaryPaymentsChart from './VoluntaryPaymentsChart.vue';
import SchedulePayments from './SchedulePayments/SchedulePayments.vue';

export default {
  components: {
    InterestRateScenario,
    PropertyValueAppreciationRate,
    DoYouWantImmediateCash,
    ConsiderVoluntaryPayments,
    SchedulePayments,
    VoluntaryPaymentsChart
  }
};
</script>

<style scoped></style>
